module.exports = __webpack_public_path__ + "img/Attendance.86758870.svg";